import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
} from "antd";
import axios from "axios";
import moment from "moment";
import { NotificationInfo, UserInfo } from "../../../../context";
import {
  AuditOutlined,
  CalendarOutlined,
  PlusOutlined,
  //   ExportOutlined,
} from "@ant-design/icons";
// import * as XLSX from "xlsx";
import MerchantEmployeeLayout from "../../../layout/MerchantEmployeeLayout";
import MerchantEmployeeAddOtherTranx from "./MerchantEmployeeAddOtherTranx";
import OtherTransactionDetails from "./OtherTransactionDetails";

const MerchantEmployeeOtherTransactions = () => {
  const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [search, setSearch] = useState("");
  const [selectedTab, setSelectedTab] = useState("list");

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Transaction Date",
      dataIndex: "transaction_date",
      align: "center",

      render: (date) => (
        <p style={{ textAlign: "left" }}>
          {moment.utc(new Date(date)).format("MMMM DD, YYYY")}
        </p>
      ),
    },
    {
      title: "Transaction Number",
      dataIndex: "transaction_no",
      align: "center",
      sorter: (a, b) => a.transaction_no - b.transaction_no,
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "left" }}>{text}</p>,
    },
    {
      title: "Cost",
      dataIndex: "cost",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {text.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p style={{ width: 40 }}>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantOtherTranxList = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
    };
    axios
      .get("user/merchant/foodpanda-report/get/transaction", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantOrderSaveList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  useEffect(() => {
    getMerchantOtherTranxList();
  }, [getMerchantOtherTranxList]);

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return (
      data.transaction_no.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleFilter = (values) => {
    var DATEFROM = moment(new Date(values.date_from)).format("YYYY-MM-DD");
    var DATETO = moment(new Date(values.date_to)).format("YYYY-MM-DD");

    var date_from = moment(`${DATEFROM}T00:00:00`).format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    var date_to = moment(`${DATETO}T23:59:00`).format("YYYY-MM-DDTHH:mm:ss");

    var params = {
      date_from,
      date_to,
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      status: 1,
    };
    setLoading(true);
    axios
      .get("user/merchant/filter/foodpanda-report/get/transaction", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Filter successful.");
        setMerchantOrderSaveList({ data, ready: true });
        setOpenFilterByDate(false);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  //   const exportToExcel = () => {
  //     const selectedColumns = [
  //       "transaction_date",
  //       "transaction_no",
  //       "customer_name",
  //       "cost",
  //     ];
  //     const filteredData = searchable.map((row) => {
  //       const filteredRow = {};
  //       selectedColumns.forEach((column) => {
  //         filteredRow[column] = row[column];
  //       });
  //       return filteredRow;
  //     });

  //     const worksheet = XLSX.utils.json_to_sheet(filteredData);
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  //     XLSX.writeFile(workbook, "digimenu_foodpanda_report.xlsx");
  //   };

  return (
    <MerchantEmployeeLayout>
      {selectedTab === "list" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Input
                id="search"
                placeholder="Search Transaction #"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  border: "2px solid #e5e5e5",
                  width: window.innerWidth < 576 ? "100%" : 300,
                }}
                size="large"
              />
            </div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setSelectedTab("form")}
              style={{ marginRight: 5 }}
            >
              Add Transaction
            </Button>

            {/* <Tooltip title="Excel Export">
              <Button
                icon={<ExportOutlined />}
                style={{ marginRight: 5 }}
                onClick={exportToExcel}
              >
                Export
              </Button>
            </Tooltip> */}

            <Tooltip title="Filter by date">
              <Button
                icon={<CalendarOutlined />}
                style={{ marginRight: 5 }}
                onClick={() => setOpenFilterByDate(true)}
              >
                Filter
              </Button>
            </Tooltip>
          </div>
          <div style={{ overflowX: "auto" }}>
            <Table
              {...tableProps}
              pagination={{
                position: ["bottomCenter"],
              }}
              columns={tableColumns}
              dataSource={searchable.length > 0 ? searchable : []}
              scroll={scroll}
              rowKey={(record) => record.transaction_id}
            />
          </div>
        </>
      )}

      {selectedTab === "form" && (
        <MerchantEmployeeAddOtherTranx
          close={() => setSelectedTab("list")}
          getMerchantOtherTranxList={() => getMerchantOtherTranxList()}
        />
      )}

      {openDrawer && (
        <OtherTransactionDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
        centered
      >
        <Form
          layout="vertical"
          name="delivery-filter3"
          initialValues={{ remember: false }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeOtherTransactions;
